import React from 'react';
import {useTranslation} from 'react-i18next';
import {Link, useLocation} from 'react-router';

import {getTitle} from 'src/utils/pageTitle';

import {ESize} from './constants';
import * as S from './style';

type TProps = {
  backToUrl?: string;
  title?: string;
  size?: keyof typeof ESize;
  noPadding?: boolean;
  onClick?: TEmptyFunction;
  titleVariables?: Record<string, string>;
  isSetPageTitle?: boolean;
};

const Header = React.memo<TProps>(
  ({
    backToUrl,
    title: titleProp,
    onClick,
    size = 'M',
    noPadding = false,
    titleVariables,
    isSetPageTitle,
  }) => {
    const {pathname} = useLocation();
    const {i18n} = useTranslation();

    const title = titleProp || getTitle(i18n, pathname, titleVariables);

    React.useEffect(() => {
      if (!isSetPageTitle) {
        return;
      }

      window.document.title = title;
    }, [title, isSetPageTitle]);

    return (
      <S.Header noPadding={noPadding}>
        <S.Title>
          {!!backToUrl && (
            <S.ArrowWrapper to={backToUrl} as={Link} size={size} onClick={onClick}>
              <S.ArrowBackIcon />
            </S.ArrowWrapper>
          )}
          {!!onClick && !backToUrl && (
            <S.ArrowWrapper onClick={onClick} size={size}>
              <S.ArrowBackIcon />
            </S.ArrowWrapper>
          )}
          <S.H1 size={size}>{title}</S.H1>
        </S.Title>
      </S.Header>
    );
  },
);

Header.displayName = 'Header';

export default Header;
